// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SlideConfig_PresentationCoverSlideConfigFragment = { __typename?: 'PresentationCoverSlideConfig', id: string, backgroundAlpha?: number | null, backgroundColor?: string | null, backgroundImagePath?: string | null, backgroundImageSvgContent?: string | null, useDarkLogo?: boolean | null, footerColor?: string | null, backgroundGradientEndColor?: string | null, backgroundGradientAngle?: number | null, backgroundOverlayPath?: string | null, backgroundOverlayAlpha?: number | null, backgroundOverlayPercentScale?: number | null, backgroundOverlayOriginX?: number | null, backgroundOverlayOriginY?: number | null, backgroundImageOriginX?: number | null, backgroundImageOriginY?: number | null, backgroundImagePercentScale?: number | null, configType: Types.PresentationCoverSlideConfigConfigType, dividerInheritCover?: boolean | null, hideLogo?: boolean | null, includeFooter?: boolean | null, logoOriginX?: number | null, logoOriginY?: number | null, logoPercentScale?: number | null, textColor?: string | null, textOriginX?: number | null, textOriginY?: number | null, textWidth?: number | null, titleTextSize?: Types.PresentationCoverSlideConfigTitleTextSize | null, titleSizeRem?: number | null, bodyTextColor?: string | null, bodyTextAlignment?: Types.PresentationCoverSlideConfigBodyTextAlignment | null, useDefaultLogoPosition?: boolean | null };

export type UpdateCoverSlideConfigMutationVariables = Types.Exact<{
  input: Types.UpdatePresentationCoverSlideConfigInput;
  subBrandID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type UpdateCoverSlideConfigMutation = { __typename?: 'Mutation', updateCoverSlideConfig: (
    { __typename?: 'PresentationCoverSlideConfig' }
    & SlideConfig_PresentationCoverSlideConfigFragment
  ) };

export type UpdateDividerSlideConfigMutationVariables = Types.Exact<{
  input: Types.UpdatePresentationCoverSlideConfigInput;
  subBrandID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type UpdateDividerSlideConfigMutation = { __typename?: 'Mutation', updateDividerSlideConfig: (
    { __typename?: 'PresentationCoverSlideConfig' }
    & SlideConfig_PresentationCoverSlideConfigFragment
  ) };

export type UploadSlideBackgroundImageMutationVariables = Types.Exact<{
  input: Types.CreatePresentationCoverSlideBackgroundImageInput;
}>;


export type UploadSlideBackgroundImageMutation = { __typename?: 'Mutation', uploadPresentationCoverSlideBackgroundImage: { __typename?: 'PresentationCoverSlideBackgroundImageUpload', uploadURL: string, uploadMethod: string, uploadURLExpiresInSeconds: number } };

export const Operations = {
  Mutation: {
    UpdateCoverSlideConfig: 'UpdateCoverSlideConfig' as const,
    UpdateDividerSlideConfig: 'UpdateDividerSlideConfig' as const,
    UploadSlideBackgroundImage: 'UploadSlideBackgroundImage' as const
  },
  Fragment: {
    SlideConfig_PresentationCoverSlideConfig: 'SlideConfig_PresentationCoverSlideConfig' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const SlideConfig_PresentationCoverSlideConfigFragmentDoc = gql`
    fragment SlideConfig_PresentationCoverSlideConfig on PresentationCoverSlideConfig {
  id
  backgroundAlpha
  backgroundColor
  backgroundImagePath
  backgroundImageSvgContent
  useDarkLogo
  footerColor
  backgroundGradientEndColor
  backgroundGradientAngle
  backgroundOverlayPath
  backgroundOverlayAlpha
  backgroundOverlayPercentScale
  backgroundOverlayOriginX
  backgroundOverlayOriginY
  backgroundImageOriginX
  backgroundImageOriginY
  backgroundImagePercentScale
  configType
  dividerInheritCover
  hideLogo
  includeFooter
  logoOriginX
  logoOriginY
  logoPercentScale
  textColor
  textOriginX
  textOriginY
  textWidth
  titleTextSize
  titleSizeRem
  bodyTextColor
  bodyTextAlignment
  useDefaultLogoPosition
}
    `;
export const UpdateCoverSlideConfigDocument = gql`
    mutation UpdateCoverSlideConfig($input: UpdatePresentationCoverSlideConfigInput!, $subBrandID: ID) {
  updateCoverSlideConfig(input: $input, subBrandID: $subBrandID) {
    ...SlideConfig_PresentationCoverSlideConfig
  }
}
    ${SlideConfig_PresentationCoverSlideConfigFragmentDoc}`;
export type UpdateCoverSlideConfigMutationFn = Apollo.MutationFunction<UpdateCoverSlideConfigMutation, UpdateCoverSlideConfigMutationVariables>;

/**
 * __useUpdateCoverSlideConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCoverSlideConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverSlideConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverSlideConfigMutation, { data, loading, error }] = useUpdateCoverSlideConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *      subBrandID: // value for 'subBrandID'
 *   },
 * });
 */
export function useUpdateCoverSlideConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoverSlideConfigMutation, UpdateCoverSlideConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoverSlideConfigMutation, UpdateCoverSlideConfigMutationVariables>(UpdateCoverSlideConfigDocument, options);
      }
export type UpdateCoverSlideConfigMutationHookResult = ReturnType<typeof useUpdateCoverSlideConfigMutation>;
export type UpdateCoverSlideConfigMutationResult = Apollo.MutationResult<UpdateCoverSlideConfigMutation>;
export type UpdateCoverSlideConfigMutationOptions = Apollo.BaseMutationOptions<UpdateCoverSlideConfigMutation, UpdateCoverSlideConfigMutationVariables>;
export const UpdateDividerSlideConfigDocument = gql`
    mutation UpdateDividerSlideConfig($input: UpdatePresentationCoverSlideConfigInput!, $subBrandID: ID) {
  updateDividerSlideConfig(input: $input, subBrandID: $subBrandID) {
    ...SlideConfig_PresentationCoverSlideConfig
  }
}
    ${SlideConfig_PresentationCoverSlideConfigFragmentDoc}`;
export type UpdateDividerSlideConfigMutationFn = Apollo.MutationFunction<UpdateDividerSlideConfigMutation, UpdateDividerSlideConfigMutationVariables>;

/**
 * __useUpdateDividerSlideConfigMutation__
 *
 * To run a mutation, you first call `useUpdateDividerSlideConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDividerSlideConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDividerSlideConfigMutation, { data, loading, error }] = useUpdateDividerSlideConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *      subBrandID: // value for 'subBrandID'
 *   },
 * });
 */
export function useUpdateDividerSlideConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDividerSlideConfigMutation, UpdateDividerSlideConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDividerSlideConfigMutation, UpdateDividerSlideConfigMutationVariables>(UpdateDividerSlideConfigDocument, options);
      }
export type UpdateDividerSlideConfigMutationHookResult = ReturnType<typeof useUpdateDividerSlideConfigMutation>;
export type UpdateDividerSlideConfigMutationResult = Apollo.MutationResult<UpdateDividerSlideConfigMutation>;
export type UpdateDividerSlideConfigMutationOptions = Apollo.BaseMutationOptions<UpdateDividerSlideConfigMutation, UpdateDividerSlideConfigMutationVariables>;
export const UploadSlideBackgroundImageDocument = gql`
    mutation UploadSlideBackgroundImage($input: CreatePresentationCoverSlideBackgroundImageInput!) {
  uploadPresentationCoverSlideBackgroundImage(input: $input) {
    uploadURL
    uploadMethod
    uploadURLExpiresInSeconds
  }
}
    `;
export type UploadSlideBackgroundImageMutationFn = Apollo.MutationFunction<UploadSlideBackgroundImageMutation, UploadSlideBackgroundImageMutationVariables>;

/**
 * __useUploadSlideBackgroundImageMutation__
 *
 * To run a mutation, you first call `useUploadSlideBackgroundImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSlideBackgroundImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSlideBackgroundImageMutation, { data, loading, error }] = useUploadSlideBackgroundImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadSlideBackgroundImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadSlideBackgroundImageMutation, UploadSlideBackgroundImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadSlideBackgroundImageMutation, UploadSlideBackgroundImageMutationVariables>(UploadSlideBackgroundImageDocument, options);
      }
export type UploadSlideBackgroundImageMutationHookResult = ReturnType<typeof useUploadSlideBackgroundImageMutation>;
export type UploadSlideBackgroundImageMutationResult = Apollo.MutationResult<UploadSlideBackgroundImageMutation>;
export type UploadSlideBackgroundImageMutationOptions = Apollo.BaseMutationOptions<UploadSlideBackgroundImageMutation, UploadSlideBackgroundImageMutationVariables>;